import { Box, Button, Typography } from '@mui/material';
import React, { Dispatch } from 'react';
import { FolderSvg } from '../../StoryList/StoryListContent/FolderSvg';
import { IPublicationViewMessages } from '../../../../types';
import { styles } from './EmptyViewContent.styles';

type IEmptyViewContentProps = {
  heading: string;
  subHeading: string;
  showButton: boolean;
  messages: IPublicationViewMessages;
  setIsCreatePublicationModalVisible: Dispatch<React.SetStateAction<boolean>>;
};

export const EmptyViewContent = (props: IEmptyViewContentProps): JSX.Element => {
  const { heading, subHeading, showButton, messages, setIsCreatePublicationModalVisible } = props;

  return (
    <Box sx={styles.centered}>
      <FolderSvg />
      <Typography variant="h2" sx={styles.heading} data-test="section-welcome-heading">
        {heading}
      </Typography>
      <Typography variant="h3" sx={styles.subHeading}>
        {subHeading}
      </Typography>
      {showButton && (
        <Button
          variant="contained"
          size="large"
          data-test="empty-section-button"
          onClick={() => setIsCreatePublicationModalVisible(true)}
        >
          {messages.addSectionTitle}
        </Button>
      )}
    </Box>
  );
};
